<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24" class="mt-2">
          <el-form-item
            :label="$l('form_label_itemNo') || '代码'"
            prop="itemNo"
          >
            <el-input
              v-model="formData.itemNo"
              :placeholder="$l('placeholder_label_itemNo') || '请输入代码'"
              maxlength="50"
              clearable
              size="small"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mt-2">
          <el-form-item
            :label="$l('form_label_itemName') || '中文名称'"
            prop="itemName"
          >
            <el-input
              type="textarea"
              :placeholder="
                $l('placeholder_label_itemName') || '请输入中文名称'
              "
              v-model="formData.itemName"
              :rows="2"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mt-2">
          <el-form-item
            :label="$l('form_label_itemNameEn') || '英文名称'"
            prop="itemNameEn"
          >
            <el-input
              type="textarea"
              :placeholder="
                $l('placeholder_label_itemNameEn') || '请输入英文名称'
              "
              v-model="formData.itemNameEn"
              :rows="2"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mt-2">
          <el-form-item
            :label="$l('form_label_defectSeverity') || '疵点位置及对应严重等级'"
            class="is-required"
            prop="defectSeverity"
            style="float: none !important;"
          >
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <DefectServerityItem
            v-for="(item, index) in defectServerityItems"
            :key="index"
            :item="item"
            :defectOption="resolveResult"
            :defectSeverities="defectSeverities"
            ref="defectServerityItemRef"
          />
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
import DefectServerityItem from "./defect-serverity-item.vue";
export default {
  mixins: [EditLoading],
  components: { DefectServerityItem },
  props: {
    dfDefinitionCode: { type: String, default: "" },
    dfDefinitionCategoryCode: { type: String, default: "" },
    dfDefinitionItemCode: { type: String, default: "" },
  },
  data() {
    return {
      fileTypeParams: { dictType: "fileType" },
      formData: {},
      rules: {
        itemNo: [
          {
            required: true,
            message: this.$l("rules_itemNo") || "请输入代码",
            trigger: "blur",
          },
        ],
        itemName: [
          {
            required: true,
            message: this.$l("rules_itemName") || "请输入中文名称",
            trigger: "blur",
          },
        ],
        itemNameEn: [
          {
            required: true,
            message: this.$l("rules_itemNameEn") || "请输入英文名称",
            trigger: "blur",
          },
        ],
      },
      defectServerityItems: [],
      defectSeverities: [],
      result: [],
      backDialogVisible: false,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    resolveResult() {
      const tmp_map = {};
      this.result.forEach((element) => {
        tmp_map[element.locationOptionCode] = element;
      });
      return tmp_map;
    },
  },
  methods: {
    getData() {
      if (!this.dfDefinitionItemCode) return this.init();
      this.$api
        .dfsDfDefinitionItemDetailApi({
          dfDefinitionItemCode: this.dfDefinitionItemCode,
        })
        .then((res) => {
          this.formData = res.body;
          this.defectServerityItems = res?.body?.defectLocations;
          this.defectSeverities = res?.body?.defectSeverities;
          this.result = res?.body?.result;
        });
    },
    init() {
      this.$api
        .dfsDfDefinitionItemValueDefectSeverityApi({
          dfDefinitionCode: this.dfDefinitionCode,
        })
        .then((res) => {
          this.defectServerityItems = res?.body?.defectLocations;
          this.defectSeverities = res?.body?.defectSeverities;
        });
    },
    async save() {
      let result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);
      const defectServerityItemRefs = this.$refs.defectServerityItemRef;

      const itemValues = [];
      if (defectServerityItemRefs) {
        for (let j = 0; j < defectServerityItemRefs.length; j++) {
          const defectServerityItemRef = defectServerityItemRefs[j];
          result = result && defectServerityItemRef.validate();
          itemValues.push(defectServerityItemRef.getData());
        }
        if (!result) {
          this.$message.warning(
            this.$l("message_tips_pls_check_ds_info") ||
              "请选择疵点位置及对应严重等级"
          );
          this.backDialogVisible = false;
          return;
        }
      }
      const params = {
        ...this.formData,
        dfDefinitionCode: this.dfDefinitionCode,
        dfDefinitionCategoryCode: this.dfDefinitionCategoryCode,
        itemValues,
      };

      this.loadingOpen();

      this.$api
        .dfsDfDefinitionItemSaveApi(params)
        .then((res) => {
          this.loadingClose();
          const { status, msg } = res;
          if (status !== 200) {
            this.$message.error(msg);
            return;
          }
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || "保存成功",
            type: "success",
          });
          this.$emit("reload");
          this.$emit("close");
        })
        .catch(() => {
          this.loadingClose();
          this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        });
    },
    cancel() {
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item:last-child {
  margin-bottom: 0px !important;
  float: none !important;
}
</style>
